import React, { useState, useEffect } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import CatalogoClaseProduc from "../../catalogos/catalogoClaseProduc";

const TablaClaseProduc = (props) => {
  const [catalogo, setCatalogo] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);

  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "Descripción",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          DESCRIPCIÓN
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "Código Clase",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CÓDIGO CLASE
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 320);

  useEffect(() => {
    if (props.tabclase) {
      setRecords(props.tabclase);
    }
  }, [props.tabclase]);

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const handleAceptaCatalogoClass = (idclass, descrip, codclass) => {
    setCatalogo(false);
    props.seleccionarCampos(idclass, descrip, codclass);
  };

  const handleEliminar = (idclass) => (e) => {
    e.preventDefault();

    props.eliminarCampos(idclass);
  };

  return (
    <div className="card">
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content">
          <div className="container">
            <div className="row col-md-12" style={{ height: "100%" }}>
              <div className="col-3 d-flex ml-auto">
                <button
                  onClick={handleCatalogo}
                  style={{ marginBottom: "5px" }}
                  disabled={
                    props.operacion === 4 || props.operacion === 3
                      ? true
                      : deshabilitado
                  }
                  className="btn btn-sm btn-primary rounded-pill ml-auto"
                >
                  <i className="fas fa-pen-square"></i> Asignar Clase
                </button>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        records.map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "left" }}
                            >
                              {item.idclaseproduccion}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "left" }}
                            >
                              {item.descripcion}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {item.codigoclaseproduccion}
                            </TableCell>
                            <TableCell
                              style={{
                                textAlign: "center",
                                fontFamily: "georgia",
                              }}
                            >
                              <button
                                onClick={handleEliminar(item.idclaseproduccion)}
                                disabled={
                                  props.operacion === 4 || props.operacion === 3
                                    ? true
                                    : deshabilitado
                                }
                                className="btn btn-sm  btn-danger rounded-circle ml-2"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              </div>
              <CatalogoClaseProduc
                show={catalogo}
                onHideCancelaCatClass={handleCatalogo}
                onHideAceptaCatClass={handleAceptaCatalogoClass}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaClaseProduc;



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/tablaClassR.js